// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFoundPage_wrapper__Cqii0","container":"NotFoundPage_container__D-Bh1"};